import {
  SpecialConditionData,
  SpecialConditionDataConditionType,
} from '@urbanx/agx.campaigns.client'

export const getDefaultCustomCondition = (
  clauseNumber?: number
): SpecialConditionData => ({
  id: window.crypto.randomUUID(),
  conditionType: SpecialConditionDataConditionType.Custom,
  overriddenClauseNumber: clauseNumber,
  clauses: [
    {
      clauseId: window.crypto.randomUUID(),
      dataPoints: [
        {
          dataPointId: window.crypto.randomUUID(),
          model: {
            custom: {
              clauseId: window.crypto.randomUUID(),
              textInput: '',
              subClauses: [
                {
                  clauseId: window.crypto.randomUUID(),
                  textInput: '',
                },
              ],
            },
          },
        },
      ],
    },
  ],
})
